export type IMaskMoneyFields = IDCA.IGenericFunc;

export function _maskMoneyFields(): void {
  $('input.money-field:not([readonly]):not(:disabled)').each((_, input) => {
    const $input = $(input);
    const allowNegative = $input.data('allow-negative') || true;
    const allowZero = $input.data('allow-zero') || true;
    const decimal = $input.data('decimal') || '.';
    const thousands =
      $input.data('thousand') && $input.data('thousand') === 'espace'
        ? ' '
        : $input.data('thousand') || '';
    const precision = $input.data('precision') || $input.hasClass('no-decimal') ? 0 : 2;
    // FD will return .00 by default on money fields, we need to strip this otherwise 400.00 will become 400000
    if ($input.hasClass('no-decimal')) {
      const val = String($input.val());
      // Remove value after period (.00)
      const newVal = val.substring(0, val.indexOf('.'));
      $input.val(newVal);
    }
    ($input as any).maskMoney({
      allowNegative,
      allowZero,
      decimal,
      precision,
      thousands,
    });
  });
}
